import posthog from 'posthog-js'

class PosthogService {
  init() {
    if (!this.isEnabled()) {
      return
    }

    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      defaults: '2025-05-24',
    })
  }

  isEnabled(): boolean {
    return !!(
      import.meta.env.VITE_PUBLIC_POSTHOG_KEY &&
      import.meta.env.VITE_PUBLIC_POSTHOG_HOST &&
      import.meta.env.VITE_ENABLE_POSTHOG === 'true'
    )
  }
}

const posthogService = new PosthogService()

export default posthogService
